



































import { Component, Vue, Prop } from 'vue-property-decorator'
import draggable from 'vuedraggable'
import { StatementSortingOptions } from '@/interfaces/SortingInterfaces'
import SurveyConfirmModal from '@/components/modals/SurveyConfirmModal.vue'

@Component({
  name: 'DragAndDropSortingStatement',
  components: { draggable, SurveyConfirmModal }
})
export default class DragAndDropSortingStatement extends Vue {
  @Prop({})
  surveyProduct!: string

  @Prop({
    default: {
      list: [],
      displayOption: 'title'
    }
  })
  options!: StatementSortingOptions
  isListChanged: boolean = false

  updateOrder () {
    if (!this.isListChanged) {
      this.$modal.show('confirm-modal')
    } else {
      this.$emit('updateOrder', this.options.list)
    }
  }

  handleCancelModal () {
    this.$modal.hide('confirm-modal')
  }

  handleConfirmModal () {
    this.$modal.hide('confirm-modal')
    this.$emit('updateOrder', this.options.list)
  }
}
